import React from 'react'
import styled from 'styled-components'
import Container from '../container'
import White from '../white'

const Outer = styled.div`
  border: 1px solid #fff;
  background-color: #fff;
  padding-top: 0px;
`

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  border-radius: 20px;
`

const Image = styled.img`
  aspect-ratio: 4/5;
  object-fit: cover;
  border-radius: 20px;
`

const LargeImage = ({module}) => {
  return (
    <Outer>
    <White>
    <Container mt0 mb0>

    <Flex>
      <div>
      <Image src={module.image.asset.publicUrl} />
      </div>

    </Flex>
    </Container>
    </White>
    </Outer>
  )
}

export default LargeImage
